import React from 'react';
import classNames from 'classnames';
import styles from './Carousel.module.scss';
import { AnalyticsEvents, AnalyticsScores, EmbedTypes } from '../consts';

const Arrow = ({ direction = 'left', disabled }) => {
  const isLeft = direction === 'left';
  const arrowClickHandler = () => {
    giggAnalytics.logEvent(AnalyticsEvents.SEE_MORE, {
      boardId: __gigg.accountId,
      boardType: EmbedTypes.CAROUSEL,
      folderId: __gigg.folderId,
      scoreWeight: AnalyticsScores.SEE_MORE,
      firstEvent: {
        _id: window.giggFirstEvent?._id,
        createdDate: window.giggFirstEvent?.createdDate,
      },
      inViewEvent: {
        _id: window.latestViewEvent?._id,
        createdDate: window.latestViewEvent?.createdDate,
      },
    });
  };
  return (
    <div
      className={classNames([styles.carouselArrow, 'gigg-carousel__arrow'], {
        [styles.carouselArrowLeft]: isLeft,
        'gigg-carousel__arrow-left': isLeft,
        [styles.carouselArrowRight]: !isLeft,
        'gigg-carousel__arrow-right': !isLeft,
        [styles.carouselArrowDisabled]: disabled,
      })}
      onClick={arrowClickHandler}
    >
      <button
        type="button"
        aria-label={isLeft ? 'carousel left button' : 'carousel right button'}
        className={classNames(styles.carouselArrowInner, 'gigg-carousel__arrow-inner')}
      >
        <div className={classNames(styles.carouselArrowIcon, 'gigg-carousel__arrow-icon')} />
      </button>
    </div>
  );
};

export default Arrow;
